import "../Styling/Footer.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram, faFacebookF, faWhatsapp, faViber } from '@fortawesome/free-brands-svg-icons'

export default function Footer({ t }) {
  return (
    <footer className="site-footer bg-[--c-dark] text-white">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-6">
            <h6 className="text-2xl">{t.footerFirstTitle}</h6>
            <p className="text-justify text-xl">{t.footerDescription}
            </p>
          </div>

          <div className="col-xs-6 col-md-3">
            <h6 className="text-2xl">{t.footerSecondTitle}</h6>
            <ul className="footer-links text-xl">
              <li>064 1227841</li>
              <li>065 3010083</li>
              <li className="break-all">bellatours.nis@gmail.com</li>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>

          <div className="col-xs-6 col-md-3">
            <h6 className="text-2xl">{t.footerThirdTitle}</h6>
            <ul className="footer-links text-xl">
              <li><Link to="/">{t.home}</Link></li>
              <li><Link to="/contact">{t.contact}</Link></li>
              <li><Link to="/about">{t.about}</Link></li>
              <li><Link to="/apartments">{t.apartments}</Link></li>
            </ul>
          </div>
        </div>
        <hr />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-sm-6 col-xs-12">
            <p className="copyright-text">Copyright &copy; 2024 All Rights Reserved by
              <a  href = "#" style={{textDecoration: "none", color: "#6b6b6b"}}> Bella</a>.
            </p>
          </div>

          <div className="col-md-4 col-sm-6 col-xs-12">
            <ul className="social-icons">
              <li><Link to="https://www.instagram.com/bella_apartmani_bovanskojezero/" target="_blank"><FontAwesomeIcon icon={faInstagram} style={{ color: 'white' }}/></Link></li>
              <li><Link to="https://www.facebook.com/bella.tours.5?mibextid=ZbWKwL" target="_blank"><FontAwesomeIcon icon={faFacebookF} style={{ color: 'white' }}/></Link></li>
              <li><Link to="https://wa.me/381653010083" target="_blank"><FontAwesomeIcon icon={faWhatsapp} style={{ color: 'white' }}/></Link></li>
              <li><Link to="viber://chat?number=+381653010083" target="_blank"><FontAwesomeIcon icon={faViber} style={{ color: 'white' }}/></Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}